import axios from 'axios';
import { ApiResponse, zps_wp } from '../zps';

export type IDispenser = {
  dispenserid: number;
  eid: number;
  entid: number;
  productName: string;
  productid: string;
  quantity: number;
  status: number;
};

export interface IDispenserRequest {
  dispenserid: number;
  eid: number;
  newQuantity: number;
  productid: string;
  quantity: number;
}

export interface IDispenserResponse extends ApiResponse {
  list: IDispenser[];
  type: string;
  totalRows: number;
}

export const fetchdispensersList = (eid: number): Promise<IDispenserResponse> => {
  const url = `${zps_wp}/api/product/dispenser?eid=${eid}`;
  return axios.get<IDispenserResponse>(url).then(res => res.data);
};

export const fetchDispenserDetails = (eid: number, dispenserid: number): Promise<IDispenserResponse> => {
  const url = `${zps_wp}/api/product/dispenser?eid=${eid}&dispenserid=${dispenserid}`;
  return axios.get<IDispenserResponse>(url).then(res => res.data);
};

export const addDispenserDetails = (request: IDispenserRequest, controller: AbortController): Promise<ApiResponse> => {
  const url = `${zps_wp}/api/product/dispenser`;
  return axios.post<ApiResponse>(url, request, { signal: controller.signal }).then(res => res.data);
};

export const updateDispenserDetails = (
  request: IDispenserRequest,
  controller: AbortController
): Promise<ApiResponse> => {
  const url = `${zps_wp}/api/product/dispenser`;
  return axios.put<ApiResponse>(url, request, { signal: controller.signal }).then(res => res.data);
};

export const deleteDispenser = (entid: number, eid: number, dispenserid: number): Promise<ApiResponse> => {
  const url = `${zps_wp}/api/product/?entid=${entid}&eid=${eid}&dispenserid=${dispenserid}`;
  return axios.delete<ApiResponse>(url).then(res => res.data);
};
